export const GRIN_SCOPE_TYPE_REGULAR = 'regular'
export const GRIN_SCOPE_TYPE_MINI = 'mini'
export const GRIN_SCOPE_TYPE_LG = 'lg'
export const GRIN_SCOPE_TYPE_LG_MINI = 'lgMini'
export const GRIN_SCOPE_MAX_IN_ORDER = 300
export const GRIN_SCOPE_MIN_IN_ORDER = 10
export const SUBSCRIPTION_PLAN_GRIN_SCOPE_MAX_IN_ORDER = 100
export const SUBSCRIPTION_PLAN_GRIN_SCOPE_MINI_MAX_IN_ORDER = 100

export const COUPON_ERRORS = {
  GENERAL: 'general',
  COUPON_INVALID_FOR_INVOICE_ITEMS: 'couponInvalidForInvoiceItems'
}
